import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, ChevronDown, ChevronUp } from "lucide-react";
import { Home, Calendar, Code } from "lucide-react";
import "./FAQ.css";
import IntlMessages from "../../intl/IntlMessages";
import { FaBorderAll } from "react-icons/fa";
import { injectIntl } from "react-intl";

// Données FAQ
const faqData = {
  immobilier: [
    {
      question: "immobilier_1",
      answer: "immobilier_2",
    },
    {
      question: "immobilier_3",
      answer: "immobilier_4",
    },
  ],
  evenementiel: [
    {
      question: "evenementiel_1",
      answer: "evenementiel_2",
    },
    {
      question: "evenementiel_3",
      answer: "evenementiel_4",
    },
  ],
  informatique: [
    {
      question: "informatique_1",
      answer: "informatique_2",
    },
    {
      question: "informatique_3",
      answer: "informatique_4",
    },
  ],
};

// Icônes des catégories
const categoryIcons = {
  immobilier: <Home className="h-5 w-5 text-primary" />,
  evenementiel: <Calendar className="h-5 w-5 text-warning" />,
  informatique: <Code className="h-5 w-5 text-success" />,
};

const FAQSection = ({ intl }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCategory, setActiveCategory] = useState("tous");
  const [openQuestions, setOpenQuestions] = useState({});
  const message = intl;

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const toggleQuestion = (categoryKey, index) => {
    setOpenQuestions((prev) => ({
      ...prev,
      [`${categoryKey}-${index}`]: !prev[`${categoryKey}-${index}`],
    }));
  };

  const filterQuestions = (questions) => {
    return questions.filter(
      (q) =>
        message.messages[q.question]
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        message.messages[q.answer]
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
    );
  };

  const getAllQuestions = () => {
    return Object.values(faqData).flat();
  };

  const categories = ["tous", ...Object.keys(faqData)];

  return (
    <div className="min-vh-100 bg-light py-5 faq-title">
      <div className="container">
        <div className="bg-AppTheme text-white py-4 text-center mb-4 rounded mt-8">
          <h2 className="display-3 mb-0 ">
            <IntlMessages id="faq.title" />
          </h2>
        </div>

        {/* Barre de recherche avec animation */}
        <div className="mb-4">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-white border-right-0">
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ repeat: Infinity, duration: 2 }}
                >
                  <Search className="h5 w-5 text-info" /> {/* Icône colorée */}
                </motion.div>
              </span>
            </div>
            <input
              type="text"
              className="form-control border-left-0"
              placeholder={"..."}
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </div>

        {/* Navigation des catégories avec recul des icônes */}
        <div className="mb-4 d-flex justify-content-center w-100 overId">
          <div className="overId-inner">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`btn btn-${
                  activeCategory === category ? "green" : "transparent"
                } mx-2 mb-4 d-flex align-items-center`}
                style={{ transform: "translateY(2px)" }} // Recul léger
              >
                {categoryIcons[category]}
                <span
                  className={`ml-2 ${
                    activeCategory === category ? "text-color" : ""
                  }`}
                >
                  {category.charAt(0).toUpperCase() + category.slice(1) ===
                  "Tous" ? (
                    <FaBorderAll size={16} />
                  ) : null}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Questions et réponses */}
        <div>
          <AnimatePresence>
            {filterQuestions(
              activeCategory === "tous"
                ? getAllQuestions()
                : faqData[activeCategory]
            ).length === 0 && searchTerm ? (
              <div className="text-center text-muted mb-4">
                <IntlMessages id="no_info_found" />
                <br />
                <a href="/contact" className="text-info">
                  <IntlMessages id="message_not_found" />
                </a>
              </div>
            ) : (
              filterQuestions(
                activeCategory === "tous"
                  ? getAllQuestions()
                  : faqData[activeCategory]
              ).map(({ question, answer }, index) =>
                <motion.div
                  key={`${activeCategory}-${index}`}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  className="border rounded mb-2 shadow-sm"
                >
                  <button
                    onClick={() => toggleQuestion(activeCategory, index)}
                    className="w-100 d-flex justify-content-between align-items-center btn text-left p-3"
                    style={{ color: "#0077C7" }}
                  >
                    <span className="font-weight-bold">{message.messages[question]}</span>
                    {openQuestions[`${activeCategory}-${index}`] ? (
                      <ChevronUp className="h5 w-5" />
                    ) : (
                      <ChevronDown className="h5 w-5" />
                    )}
                  </button>

                  <AnimatePresence>
                    {openQuestions[`${activeCategory}-${index}`] && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="p-3 bg-light"
                      >
                        <p className="text-muted">{message.messages[answer]}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              )
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(FAQSection);
